<div class="TotemWidget TotemWidgetCountdown card text-white" [style.backgroundImage]="getBackgroundImage()" role="region" [attr.aria-label]="location">
    <div class="card-body">
        <div class="TotemWidgetCountdown-Content">
            <div class="TotemWidgetCountdown-Content-DateTime d-flex justify-content-center mb-3">
                <div [class.me-3]="showTime !== false">
                    <i class="fa-regular fa-calendar me-2 fa-lg opacity-80" aria-hidden="true"></i>
                    <span>{{getCurrentDate() | locFormat:'date'}}</span>
                </div>
                @if (showTime !== false) {
                    <div>
                        <i class="fa-regular fa-clock me-2 fa-lg opacity-80" aria-hidden="true"></i>
                        <span>{{getCurrentDate() | locFormat:'time'}}</span>
                    </div>
                }
            </div>
            @if (displayCountdown) {
                <div class="TotemWidgetCountdown-Content-Missing d-flex justify-content-center mb-3" role="timer" aria-live="polite">
                    <div class="mx-1">
                        <div>{{ displayCountdown.days }}</div>
                        <div>{{'totem-widget-destination.missing-days' | locTranslate}}</div>
                    </div>
                    <div class="mx-1">
                        <div>{{ displayCountdown.hours }}</div>
                        <div>{{'totem-widget-destination.missing-hours' | locTranslate}}</div>
                    </div>
                    <div class="mx-1">
                        <div>{{ displayCountdown.minutes }}</div>
                        <div>{{'totem-widget-destination.missing-minutes' | locTranslate}}</div>
                    </div>
                </div>
            }
            <div class="TotemWidgetCountdown-Content-Location">
                <div class="text-center m-0">{{location}}</div>
            </div>
            @if (forecast) {
                <div class="TotemWidgetCountdown-Content-Weather d-flex justify-content-center align-items-center mt-3">
                    <div class="me-3" [innerHTML]="forecast.getDisplay() | safe:'html'"></div>
                    <div class="me-3">{{forecast.getTemperature('max')}}° C</div>
                    <div>{{forecast.getTemperature('min')}}° C</div>
                </div>
            }
        </div>
    </div>
</div>
